import React from 'react'
import collapseIcon from '../../assets/images/collapse-alt-svgrepo-com-w.svg'
import expandIcon from '../../assets/images/expand-svgrepo-com-w.svg'

interface Props {
  tableHeaders: any[]
  isReadOnly: boolean
  monthTransform: (month: string) => string
  t: (key: string) => string
  allGhOpen: boolean
  expandAll: () => void
}

const COL_CHECKBOX = 40
const COL_NAME = 240
const COL_MONTH = 150
const COL_TOTAL = 140

const BudgetTableHeader: React.FC<Props> = ({
  tableHeaders,
  isReadOnly,
  monthTransform,
  t,
  allGhOpen,
  expandAll,
}) => {
  return (
    <div className="v-table-header">
      {/* Checkbox col */}
      {
        <div
          className="v-table-header-cell v-sticky-left-1 cursor-pointer"
          style={{ width: COL_CHECKBOX, minWidth: COL_CHECKBOX }}
          title={allGhOpen ? t('label.collapseAll') : t('label.expandAll')}
          onClick={expandAll}
        >
          <img
            src={allGhOpen ? collapseIcon : expandIcon}
            alt=""
            style={{ height: '20px' }}
          />
        </div>
      }

      {/* Account name — sticky */}
      <div
        className="v-table-header-cell v-sticky-left-2"
        style={{
          width: COL_NAME,
          minWidth: COL_NAME,
          left: isReadOnly ? 0 : COL_CHECKBOX,
        }}
      >
        {t('label.accountName')}
      </div>

      {/* Month cols */}
      {tableHeaders.map((cal: any, i: number) => (
        <div
          key={i}
          className="v-table-header-cell"
          style={{
            width: COL_MONTH,
            minWidth: COL_MONTH,
            justifyContent: isReadOnly ? 'left' : 'center',
          }}
        >
          {monthTransform(cal?.month)} {cal?.year}
        </div>
      ))}

      {/* Total */}
      <div
        className="v-table-header-cell"
        style={{
          width: COL_TOTAL,
          minWidth: COL_TOTAL,
          justifyContent: 'flex-end',
          paddingRight: 14,
        }}
      >
        {t('label.total')}
      </div>
    </div>
  )
}

export default BudgetTableHeader
